import { Alert, Button } from '@mantine/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { api } from '../api';
import { errorMessage } from '../format';

/**
 * Asks Rethink to renew a license: opens a renewal thread, or the one
 * already open, and opens its conversation page. Every role may send
 * messages, so every role gets the button.
 */
export function RequestRenewal({ licenseId }: { licenseId: string }) {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const request = useMutation({
    mutationFn: () => api.licenses.requestRenewal(licenseId),
    onSuccess: async (r) => {
      await qc.invalidateQueries({ queryKey: ['threads'] });
      await navigate({ to: '/messages/$threadId', params: { threadId: r.threadId } });
    },
  });
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Button variant="default" h={40} loading={request.isPending} onClick={() => request.mutate()}>
        Request renewal
      </Button>
      {request.error && (
        <Alert color="red" variant="light">
          {errorMessage(request.error)}
        </Alert>
      )}
    </div>
  );
}
